export enum RoleTelemetryKeys {
  WasRoleNameChanged = 'IAM_wasRoleNameChanged',
  RoleType = 'IAM_roleType',
  IsEventFromRolesDetails = 'IAM_isEventFromRolesDetails',
  NoOfUsersSelected = 'IAM_noOfUsersSelected',
  NoOfGroupsSelected = 'IAM_noOfGroupsSelected',
  TargetObjectId = 'IAM_targetObjectId',
  ErrorReason = 'IAM_errorReason',
  ErrorEvent = 'IAM_isErrorEvent',
  Role = 'IAM_role',
  ErrorCode = 'IAM_errorCode',
}

export const UNKNOWN_ERROR = 'Unknown Error';
export const NETWORK_ERROR = 'Network Error';

export type TelemetryKeys = RoleTelemetryKeys;
